import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {
  PriceRuleCreateBySuperAdmin,
  UpdatePriceRateSuperAdmin,
} from '../GlobalRateCardSlice/GlobalRateCardSlice'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import {getAccountIdList} from '../../../AllCellCastUser/UserListSlice/UserListSlice'
import Select from 'react-select'

const AddNewPriceRule = ({show, handleClose, data, accId}: any) => {
  const dispatch = useDispatch()
  const [error, setError] = useState<any>({})
  const [priceData, setPriceData] = useState<any>({
    finalPrice: '',
    actualPrice: '',
    creditstartrange: '',
    creditendrange: '',
    type: 'SMS',
    accountId: accId,
  })
  const accountIdList = useSelector(getAccountIdList)

  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true

  const handleSubmit = () => {
    if (Object.keys(Validation(priceData)).length == 0) {
      if (!data?._id) {
        dispatch(PriceRuleCreateBySuperAdmin(priceData))
        setPriceData({
          finalPrice: '',
          actualPrice: '',
          creditstartrange: '',
          creditendrange: '',
          type: 'SMS',
          accountId: accId,
        })
        handleClose()
      } else {
        dispatch(UpdatePriceRateSuperAdmin({priceData: priceData, id: data?._id}))
        setPriceData({
          finalPrice: '',
          actualPrice: '',
          creditstartrange: '',
          creditendrange: '',
          type: 'SMS',
        })
        handleClose()
      }
    }
  }

  useEffect(() => {
    if (data?._id) {
      setPriceData({...priceData, ...data})
    } else {
      setPriceData({
        finalPrice: '',
        actualPrice: '',
        creditstartrange: '',
        creditendrange: '',
        type: 'SMS',
        accountId: accId,
      })
    }
  }, [data])

  const Validation = (val: any) => {
    const errors: any = {}

    if (!/^[1-9][0-9]*$/.test(val?.creditstartrange)) {
      errors.creditstartrange = 'Please enter From'
    }
    if (!/^[1-9][0-9]*$/.test(val?.creditendrange)) {
      errors.creditendrange = 'Please enter To'
    }
    if (!/^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/.test(val?.actualPrice)) {
      errors.actualPrice = 'Please enter Cost Price'
    }

    if (!/^(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)$/.test(val?.finalPrice)) {
      errors.finalPrice = 'Please enter Final price'
    }
    setError({...errors})

    return errors
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h1>Add Price Rule</h1>
        </div>
        <div className='modal-body p-10 '>
          <div className='row mb-2 justify-content-center'>
            {!isUserWhiteLabel && (
              <>
                <label className='col-form-label required fw-bold fs-6'>Account ID</label>
                <Select
                  value={{
                    value: accountIdList?.find((key: any) => key?._id === priceData?.accountId)
                      ?._id,
                    label: accountIdList?.find((key: any) => key?._id === priceData?.accountId)
                      ?.companyName,
                  }}
                  name='accountId'
                  className='form-select form-select-solid form-select-lg'
                  onChange={(e: any) => setPriceData({...priceData, accountId: e.value})}
                  options={accountIdList?.map((key: any, index: any) => ({
                    value: `${key?._id}`,
                    label: `${key?.companyName}`,
                  }))}
                />
                {/* <select
                  value={priceData?.accountId}
                  disabled={data?._id !== undefined}
                  name='accountId'
                  onChange={(e: any) => setPriceData({...priceData, accountId: e.target.value})}
                  className='form-select form-select-solid form-select-lg'
                >
                  {accountIdList?.map((key: any, index: any) => {
                    return <option value={key?._id}>{key?.companyName}</option>
                  })}
                </select> */}
              </>
            )}

            <label className='my-5'>Type</label>
            <div className='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12'>
              <input
                type='radio'
                className='btn-check'
                name='SMS'
                checked={priceData?.type == 'SMS'}
                id='quick_sms_radio2'
                onChange={() => {
                  setPriceData({...priceData, ['type']: 'SMS'})
                }}
              />
              <label
                className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
                htmlFor='quick_sms_radio2'
              >
                <span className='fw-500 fs-5'>SMS</span>
              </label>
            </div>
            <div className='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12'>
              <input
                type='radio'
                className='btn-check'
                name='MMS'
                checked={priceData?.type == 'MMS'}
                id='quick_mms_radio2'
                onChange={() => {
                  setPriceData({...priceData, ['type']: 'MMS'})
                }}
              />
              <label
                className='btn btn-outline btn-outline-dashed btn-outline-default w-100 p-4'
                htmlFor='quick_mms_radio2'
              >
                <span className='fw-500 fs-5'>MMS</span>
              </label>
            </div>

            <div className='row mt-5'>
              <div className='col-6'>
                <label className='m-5'>
                  From
                  <input
                    onChange={(e: any) =>
                      setPriceData({...priceData, [e.target.name]: e.target.value})
                    }
                    value={priceData?.creditstartrange}
                    name='creditstartrange'
                    className={`form-control-lg  m-3 ms-0 ${
                      error?.creditstartrange ? 'error' : 'form-control-solid form-control'
                    }`}
                    placeholder='Creadit From'
                  />
                </label>
              </div>

              <div className='col-6'>
                <label className='m-5'>
                  TO
                  <input
                    onChange={(e: any) =>
                      setPriceData({...priceData, [e.target.name]: e.target.value})
                    }
                    name='creditendrange'
                    value={priceData?.creditendrange}
                    className={`form-control-lg  m-3 ms-0 ${
                      error?.creditendrange ? 'error' : 'form-control-solid form-control'
                    }`}
                    placeholder='Creadit To'
                  />
                </label>
              </div>
            </div>

            <div className='row'>
              <div className='col-6'>
                <label className='m-5 my-0'>
                  Cost Price
                  <input
                    onChange={(e: any) =>
                      setPriceData({...priceData, [e.target.name]: e.target.value})
                    }
                    name='actualPrice'
                    value={priceData?.actualPrice}
                    className={`form-control-lg  m-3 ms-0 ${
                      error?.actualPrice ? 'error' : 'form-control-solid form-control'
                    }`}
                    placeholder='Cost price per credit'
                  />
                </label>
              </div>
              <div className='col-6'>
                <label className='m-5 my-0'>
                  Final Price
                  <input
                    onChange={(e: any) =>
                      setPriceData({...priceData, [e.target.name]: e.target.value})
                    }
                    name='finalPrice'
                    value={priceData?.finalPrice}
                    className={`form-control-lg  m-3 ms-0 ${
                      error?.finalPrice ? 'error' : 'form-control-solid form-control'
                    }`}
                    placeholder='Sell price per credit'
                  />
                </label>
              </div>
            </div>
          </div>
          <div className='d-flex flex-center mt-5'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
              >
                Cancel
              </button>
            </div>
            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
              onClick={handleSubmit}
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default AddNewPriceRule
